import { ContentType } from "authory-api-types";

export const ALLOW_PDF_DOWNLOAD_TYPES = [ContentType.Article, ContentType.PdfFile];
